export class Settings {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    public static readonly SymbolCherries: number = 1;
    public static readonly SymbolLemon: number = 2;
    public static readonly SymbolOrange: number = 3;
    public static readonly SymbolPlum: number = 4;
    public static readonly SymbolGrapes: number = 5;
    public static readonly SymbolBar: number = 6;
    public static readonly SymbolStar: number = 7;
    public static readonly SymbolSeven: number = 8;
    public static readonly SymbolWitch: number = 9; // WILD
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Settings.ts
 **/